// Design tokens (matched to the public storefront at nycmanufacturing.com)
const ink = "#0A0A0F";
const paper = "#F4F2EC";
const white = "#FFFFFF";
const accent = "#0033FF";
const rule = "rgba(10,10,15,0.12)";
const muted = "rgba(10,10,15,0.58)";
const success = "#22c55e";
const successInk = "#0c3a2a";
const danger = "#ef4444";
const fontBody = "'Archivo', system-ui, sans-serif";
const fontMono = "'JetBrains Mono', monospace";

const S = {
  root: {
    fontFamily: fontBody,
    background: paper,
    color: ink,
    minHeight: "100vh",
    display: "flex",
  },
  contentArea: { flex: 1, marginLeft: 260, minHeight: "100vh" },
  subNav: {
    borderBottom: `2px solid ${ink}`,
    background: paper,
    padding: "10px 24px",
    display: "flex",
    alignItems: "center",
  },
  nav: {
    display: "flex",
    gap: 0,
    background: white,
    borderRadius: 0,
    padding: 0,
    border: `2px solid ${ink}`,
    flexWrap: "nowrap",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
  },
  navBtn: {
    display: "flex",
    alignItems: "center",
    gap: 7,
    padding: "10px 16px",
    borderRadius: 0,
    border: "none",
    background: "transparent",
    color: ink,
    fontSize: 13,
    fontWeight: 600,
    cursor: "pointer",
    fontFamily: fontBody,
    transition: "all .15s",
    whiteSpace: "nowrap",
    flexShrink: 0,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
  },
  navBtnActive: { background: accent, color: white },
  main: { maxWidth: 1200, margin: "0 auto", padding: "24px 16px 60px", width: "100%" },
  // For the wide-table pages (Products runs to 15 columns on VV). Capping them
  // at 1200 left dead space beside a table that had to scroll sideways.
  mainWide: { maxWidth: 1720, margin: "0 auto", padding: "24px 16px 60px", width: "100%" },
  label: {
    display: "block",
    fontSize: 11,
    fontWeight: 600,
    color: muted,
    marginBottom: 6,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    fontFamily: fontMono,
  },
  input: {
    width: "100%",
    padding: "10px 14px",
    borderRadius: 0,
    border: `2px solid ${ink}`,
    background: white,
    color: ink,
    fontSize: 15,
    fontFamily: fontBody,
    outline: "none",
    transition: "border-color .15s",
    marginBottom: 0,
    WebkitAppearance: "none",
    MozAppearance: "none",
    appearance: "none",
  },
  selectBtn: {
    width: "100%",
    padding: "10px 14px",
    borderRadius: 0,
    border: `2px solid ${ink}`,
    background: white,
    color: ink,
    fontSize: 15,
    fontFamily: fontBody,
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    textAlign: "left",
  },
  dropdownMenu: {
    position: "absolute",
    top: "calc(100% + 4px)",
    left: 0,
    right: 0,
    background: white,
    border: `2px solid ${ink}`,
    borderRadius: 0,
    zIndex: 100,
    maxHeight: 220,
    overflowY: "auto",
    boxShadow: `4px 4px 0 ${ink}`,
  },
  dropdownItem: { padding: "10px 14px", fontSize: 15, cursor: "pointer", transition: "background .1s" },
  lineCard: { background: white, border: `2px solid ${ink}`, borderRadius: 0, overflow: "hidden" },
  lineCardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 20px",
    background: paper,
    borderBottom: `2px solid ${ink}`,
  },
  lineCardNumber: {
    fontSize: 11,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.1em",
    color: muted,
    fontFamily: fontMono,
  },
  lineCardCost: { fontFamily: fontMono, fontSize: 16, fontWeight: 700, color: accent },
  lineCardBody: { padding: "20px 20px 16px" },
  selectionGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 16px" },
  paramsRow: { display: "flex", gap: 16, marginTop: 4 },
  priceTag: {
    marginBottom: 16,
    background: paper,
    border: `2px solid ${ink}`,
    borderRadius: 0,
    padding: "10px 16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  lineResultBar: {
    marginTop: 16,
    display: "flex",
    gap: 16,
    flexWrap: "wrap",
    alignItems: "center",
    background: paper,
    borderRadius: 0,
    padding: "12px 18px",
    border: `2px solid ${ink}`,
  },
  lineResultItem: { display: "flex", flexDirection: "column", gap: 2 },
  removeLineBtn: {
    background: "none",
    border: `2px solid ${ink}`,
    borderRadius: 0,
    padding: "5px 7px",
    cursor: "pointer",
    color: ink,
    display: "inline-flex",
    alignItems: "center",
    transition: "all .15s",
  },
  addLineBtn: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "10px 20px",
    borderRadius: 0,
    border: `2px solid ${accent}`,
    background: "transparent",
    color: accent,
    fontSize: 14,
    fontWeight: 700,
    cursor: "pointer",
    fontFamily: fontBody,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    transition: "all .15s",
  },
  clearBtn: {
    padding: "10px 16px",
    borderRadius: 0,
    border: `2px solid ${ink}`,
    background: "transparent",
    color: ink,
    fontSize: 14,
    cursor: "pointer",
    fontFamily: fontBody,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
  },
  laborCard: { marginTop: 20, background: white, border: `2px solid ${ink}`, borderRadius: 0, overflow: "hidden" },
  laborCardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 20px",
    background: paper,
    borderBottom: `2px solid ${ink}`,
  },
  laborCardBody: { padding: "20px 20px 16px" },
  laborResultBar: {
    marginTop: 16,
    display: "flex",
    gap: 16,
    flexWrap: "wrap",
    alignItems: "center",
    background: paper,
    borderRadius: 0,
    padding: "12px 18px",
    border: `2px solid ${ink}`,
  },
  grandTotalCard: { marginTop: 0, background: white, border: `2px solid ${ink}`, borderRadius: 0, overflow: "hidden" },
  grandTotalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 20px",
    borderBottom: `2px solid ${ink}`,
  },
  summaryRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 20px",
    borderBottom: `1px solid ${rule}`,
    gap: 12,
  },
  summaryNumber: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 22,
    height: 22,
    borderRadius: 0,
    background: ink,
    color: white,
    fontSize: 11,
    fontWeight: 700,
    flexShrink: 0,
    fontFamily: fontMono,
  },
  grandTotalBar: {
    margin: 12,
    background: accent,
    borderRadius: 0,
    padding: "18px 22px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: white,
  },
  profitBar: {
    marginTop: 12,
    background: success,
    borderRadius: 0,
    padding: "16px 18px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: successInk,
  },
  activeInput: { borderColor: accent },
  tableWrap: { overflowX: "auto", borderRadius: 0, border: `2px solid ${ink}` },
  table: { width: "100%", borderCollapse: "collapse", fontSize: 15 },
  th: {
    textAlign: "left",
    padding: "12px 16px",
    fontSize: 11,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.1em",
    color: ink,
    borderBottom: `2px solid ${ink}`,
    background: paper,
    fontFamily: fontMono,
  },
  td: { padding: "10px 16px", borderBottom: `1px solid ${rule}`, color: ink, verticalAlign: "middle" },
  typeBadge: {
    display: "inline-block",
    padding: "3px 10px",
    borderRadius: 0,
    fontSize: 11,
    fontWeight: 700,
    background: "transparent",
    color: ink,
    border: `1px solid ${ink}`,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    fontFamily: fontMono,
  },
  iconBtn: {
    background: "none",
    border: `2px solid ${ink}`,
    borderRadius: 0,
    padding: "5px 7px",
    cursor: "pointer",
    color: ink,
    display: "inline-flex",
    alignItems: "center",
    transition: "all .15s",
  },
  addBtn: {
    display: "flex",
    alignItems: "center",
    gap: 7,
    padding: "8px 16px",
    borderRadius: 0,
    border: `2px solid ${accent}`,
    background: "transparent",
    color: accent,
    fontSize: 13,
    fontWeight: 700,
    cursor: "pointer",
    fontFamily: fontBody,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    transition: "all .15s",
  },
  cellInput: {
    width: "100%",
    padding: "6px 10px",
    borderRadius: 0,
    border: `2px solid ${accent}`,
    background: white,
    color: ink,
    fontSize: 14,
    fontFamily: fontBody,
    outline: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    appearance: "none",
  },
  editingRow: { background: "rgba(0,51,255,0.06)" },
  addingRow: { background: "rgba(0,51,255,0.06)" },
  statCard: {
    background: white,
    border: `2px solid ${ink}`,
    borderRadius: 0,
    padding: "14px 16px",
    display: "flex",
    flexDirection: "column",
    gap: 6,
    minWidth: 0,
  },
  statLabel: {
    fontSize: 11,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.1em",
    color: muted,
    fontFamily: fontMono,
  },
  statValue: { fontSize: 28, fontWeight: 700, fontFamily: fontMono, color: ink, letterSpacing: "-0.02em" },
  monthHeader: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "14px 20px",
    background: white,
    border: `2px solid ${ink}`,
    borderRadius: 0,
    cursor: "pointer",
    fontFamily: fontBody,
    marginBottom: 2,
    transition: "background .15s",
    color: ink,
  },
  jobCountBadge: {
    fontSize: 11,
    fontWeight: 700,
    background: "transparent",
    color: ink,
    border: `1px solid ${ink}`,
    padding: "3px 10px",
    borderRadius: 0,
    fontFamily: fontMono,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
  },
  saveJobBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    width: "100%",
    padding: "14px 20px",
    borderRadius: 0,
    border: `2px solid ${accent}`,
    background: accent,
    color: white,
    fontSize: 14,
    fontWeight: 700,
    cursor: "pointer",
    fontFamily: fontBody,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    transition: "all .15s",
  },
  editBanner: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 20px",
    background: paper,
    border: `2px solid ${accent}`,
    borderRadius: 0,
    color: accent,
    fontWeight: 700,
  },
  jobLink: {
    background: "none",
    border: "none",
    color: accent,
    fontFamily: fontMono,
    fontSize: 14,
    fontWeight: 700,
    cursor: "pointer",
    textDecoration: "underline",
    textUnderlineOffset: 3,
    padding: 0,
  },
  approveBtn: {
    background: "none",
    border: `2px solid ${success}`,
    borderRadius: 0,
    padding: "5px 7px",
    cursor: "pointer",
    color: success,
    display: "inline-flex",
    alignItems: "center",
    transition: "all .15s",
  },
  cancelBtn: {
    background: "none",
    border: `2px solid ${danger}`,
    borderRadius: 0,
    padding: "5px 7px",
    cursor: "pointer",
    color: danger,
    display: "inline-flex",
    alignItems: "center",
    transition: "all .15s",
  },
  toast: {
    position: "fixed",
    bottom: 24,
    left: "50%",
    transform: "translateX(-50%)",
    background: paper,
    border: `2px solid ${ink}`,
    borderRadius: 0,
    padding: "14px 24px",
    display: "flex",
    alignItems: "center",
    gap: 20,
    zIndex: 999,
    boxShadow: `4px 4px 0 ${ink}`,
    overflow: "hidden",
    minWidth: 320,
    color: ink,
  },
  undoBtn: {
    padding: "6px 16px",
    borderRadius: 0,
    border: `2px solid ${accent}`,
    background: "transparent",
    color: accent,
    fontSize: 13,
    fontWeight: 700,
    cursor: "pointer",
    fontFamily: fontBody,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
  },
};

export default S;
